var VERSION = 1789978653902

export  {
	VERSION
} 
